module.exports = __webpack_public_path__ + "preview-eac7acfc/open-sans-bold-08328bf7467540700abeb7718042f955.woff";